import { WsError } from '../wsErrors/WsError';
import { WsRequest } from './WsRequest';

export class WsResponse<WsResponse, Error extends WsError = WsError> {
  public attempts = 0;
  private rejectPromise: (error: Error) => void;
  private resolvePromise: (data: unknown) => void;

  private rejected = false;
  private resolved = false;

  private responsePromise: Promise<WsResponse>;

  constructor(public request: WsRequest) {
    this.responsePromise = new Promise((resolve, reject) => {
      this.resolvePromise = resolve;
      this.rejectPromise = reject;
    });
  }

  get isCompleted(): boolean {
    return this.resolved || this.rejected;
  }

  resolve(data: unknown): void {
    this.attempts = 0;
    this.resolved = true;
    this.resolvePromise(data);
  }

  setAttempts(attempts: number): void {
    this.attempts = attempts;
  }

  reject(error: Error): void {
    this.attempts = 0;
    this.rejected = true;
    this.rejectPromise(error);
  }

  get promise(): Promise<WsResponse> {
    return this.responsePromise;
  }
}
